import { Component, OnInit, NgZone } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { NgxUiLoaderService, Loader, SPINNER, POSITION, PB_DIRECTION } from 'ngx-ui-loader';
import { ApiService } from '../../../_services/api.service';
import { first } from 'rxjs/operators';
declare var $: any;

@Component({
  selector: 'app-cnamgs-reportlist',
  templateUrl: './cnamgs-reportlist.component.html',
  styleUrls: ['./cnamgs-reportlist.component.scss']
})
export class CnamgsReportlistComponent implements OnInit {

  reportData: any;
  response: any;
  cnamgsreportList: any;
  reSubmitData: any;
  accountDetails: any;
  paymentSuccess: any;
  reportStatus: any;
  constructor(private router: Router,
    private ngZone: NgZone,
    private ngxUiLoaderService: NgxUiLoaderService,
    private api: ApiService) {

    if (this.router.getCurrentNavigation().extras.state) {
      this.reportData = this.router.getCurrentNavigation().extras.state.data;
      this.reSubmitData = this.router.getCurrentNavigation().extras.state.resubmitData;
      this.paymentSuccess = this.router.getCurrentNavigation().extras.state.payment_success;
      if (this.paymentSuccess == 1) {
        setTimeout(() => {
          $('#paymentSuccess').modal('show');
        }, 500)
      }
      console.log(this.reportData, "Line29")
      console.log(this.reSubmitData, "Line 30")
    }
    this.reportStatus = '5';
    const data = localStorage.getItem('currentUserDetails');
    if (data) {
      this.accountDetails = JSON.parse(data);
    }
  }

  ngOnInit() {
    AOS.init({
      disable: function() {
        var maxWidth = 600;
        return window.innerWidth < maxWidth;
      }
    });
    this.getcnamgsReport();
  }
  onFilterChange() {
    console.log('reportStatus', this.reportStatus)
    this.reportData = null;
    this.reSubmitData = null;
    this.getcnamgsReport();

  }

  gotoUrl() {
    this.router.navigate(['/cnamgs-report'], { state: { data: '3' } });
  }

  getcnamgsReport() {
    let data = {
      entityType: this.reportStatus
    }
    console.log(data)
    if (data) {
      this.ngxUiLoaderService.start();
      this.api.getcnamgsreportList(data).pipe(first())
        .subscribe(res => {
            this.ngxUiLoaderService.stop();
            this.response = res;
            if (this.response && this.response.status == 200) {
              this.cnamgsreportList = this.response.result;
              if (this.reportData || this.reSubmitData) {
                $('#successModal').modal('show');
              }
            } else {

            }
          },
          error => {
            this.ngxUiLoaderService.stop();
          });
    }

  }

  getViewofReports(uuid, status) {
    localStorage.setItem('reportid', uuid)
    console.log(uuid)
    console.log("68", status)
    if (status == 'rejectedCnamgs') {
      console.log("70")
      this.router.navigate(['cnamgs-report', uuid]);
    } else {
      this.router.navigate(['/cnamgs-reportview', uuid]);
    }

  }
  openDoc() {
    this.ngxUiLoaderService.start();
    this.api.getcnamgsPdf().pipe(first())
      .subscribe(data => {
          this.ngxUiLoaderService.stop();
          console.log("263", data)
          if (data.status == 200) {
            window.open(data.imagePath, '_blank');
          } else {
            // this.snackBar.open(data.message, "OK", {
            //   duration: 5000,
            // });
          }
        },
        error => {
          this.ngxUiLoaderService.stop();
        });
  }

}
